import { render, staticRenderFns } from "./Return_product_list.vue?vue&type=template&id=4ace8330&scoped=true&"
import script from "./Return_product_list.vue?vue&type=script&lang=js&"
export * from "./Return_product_list.vue?vue&type=script&lang=js&"
import style0 from "./Return_product_list.vue?vue&type=style&index=0&id=4ace8330&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ace8330",
  null
  
)

export default component.exports